import { DashboardTab } from 'src/modules/user/types/dashboard'
import { SentRemindersTab } from 'src/modules/reminder/containers'
import {
  AutoActivatedRemindersTab,
  EnabledRemindersTab,
  FutureEventsTab,
  UnsetEventsTab,
} from 'src/modules/event/containers'

export const dashboardTabs: DashboardTab[] = [
  {
    key: 'allAppointments',
    icon: 'schedule',
    tabColor: '#5777DA',
    title: 'All Appointments',
    description: 'in your calendar',
    component: FutureEventsTab,
  },
  {
    key: 'activeReminders',
    icon: 'bell',
    tabColor: '#55AFB0',
    title: 'Active Reminders',
    description: 'next 30 days',
    component: EnabledRemindersTab,
  },
  {
    key: 'autoActivatedReminders',
    icon: 'sparkles',
    tabColor: '#D4A843',
    title: 'Auto-activated Reminders',
    description: 'auto-activated in this period',
    titleId: 'dashboard.tabs.autoActivated.title',
    descriptionId: 'dashboard.tabs.autoActivated.description',
    component: AutoActivatedRemindersTab,
  },
  {
    key: 'unsetAppointments',
    icon: 'warning',
    tabColor: '#59A6DE',
    title: 'Unset Appointments',
    description: 'without reminders',
    component: UnsetEventsTab,
  },
  {
    key: 'sentReminders',
    icon: 'phone',
    tabColor: '#908EF2',
    title: 'Sent Reminders',
    description: 'sent in last 30 days',
    component: SentRemindersTab,
  },
]
